import { render, staticRenderFns } from "./nbviewedminutescard.vue?vue&type=template&id=3ba4e900&scoped=true&"
import script from "./nbviewedminutescard.vue?vue&type=script&lang=js&"
export * from "./nbviewedminutescard.vue?vue&type=script&lang=js&"
import style0 from "./nbviewedminutescard.vue?vue&type=style&index=0&id=3ba4e900&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4e900",
  null
  
)

export default component.exports